function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("path", {
  d: "M524.83 100.37s17.52-16.87 44.83 10.03c28.21 27.79 11.52 46.86 11.52 46.86L337.7 400.48l-56.76-56.21 243.9-243.9z"
}), React.createElement("path", {
  d: "M522.58 306.44c2.65 12.41 4.09 25.27 4.15 38.46.42 103.17-82.87 187.15-186.04 187.58-103.17.42-187.15-82.87-187.57-186.04-.43-103.17 82.86-187.14 186.03-187.57 15.8-.06 31.13 1.85 45.8 5.48l58-58a255.03 255.03 0 00-102.67-21.01C198.9 85.92 84.76 201 85.34 342.39 85.92 483.77 201 597.9 342.39 597.33c141.38-.58 255.52-115.66 254.94-257.05a255.3 255.3 0 00-17.23-91.3l-57.52 57.46z"
}));

var SvgElvantoIcon = function SvgElvantoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 683 683",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgElvantoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elvanto-icon.1d47a603.svg";
export { ForwardRef as ReactComponent };